var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PO_Creation"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PO_Creation",
    "data-name": "PO Creation",
    clipPath: "url(#clip-PO_Creation)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465",
    transform: "translate(-537.144 -487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753",
    transform: "translate(538.144 488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-button",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19440",
    "data-name": "Path 19440",
    d: "M96.8,106.6a9,9,0,1,1,9-8.987A9.009,9.009,0,0,1,96.8,106.6Zm-7.7-9.024a7.712,7.712,0,1,0,7.779-7.694A7.732,7.732,0,0,0,89.1,97.576Z",
    transform: "translate(-87.8 -88.6)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19442",
    "data-name": "Path 19442",
    d: "M6,9.727l1.385,1.742L11.4,7.648",
    transform: "translate(0.302 -0.559)",
    fill: "none",
    stroke: "#0072ce",
    strokeLinecap: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoCreation);
export default __webpack_public_path__ + "static/media/PO Creation.9e8e7e522d5495ed00376215312d2432.svg";
export { ForwardRef as ReactComponent };